import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext.jsx';
export default function ClinicalNoteProvenance({note}) {
 const {t}=useLanguage();
 return <div data-testid="clinical-note-provenance" data-report-id={note?.authorityReportId||''} className="my-3 text-body-small text-on-surface-var"><p>{t(note?.authorityReportId?'clinical.noteApproved':'clinical.notePending')}</p>{note?.authorityReportId&&<p>{note.authorityReportId} · v{note.noteVersion} · {note.finalizedAt}</p>}</div>;
}
